window.numeral = require('numeral');

require('numeral/locales/en-gb');

numeral.locale('en-gb');

Vue.filter('currency', (value) => {
    return numeral(value / 100).format('$0,0.00');
});

Vue.component('products-page', require('./components/ProductsPage.vue').default);
Vue.component('products-list', require('./components/ProductsList.vue').default);
Vue.component('product-form', require('./components/ProductForm.vue').default);

Vue.component('orders-page', require('./components/OrdersPage.vue').default);
Vue.component('orders-list', require('./components/OrdersList.vue').default);

Vue.component('shop-page', require('./components/Shop/ShopPage.vue').default);
Vue.component('shop-product-page', require('./components/Shop/ProductPage.vue').default);
Vue.component('shop-products-list', require('./components/Shop/ProductsList.vue').default);
Vue.component('shop-cart', require('./components/Shop/Cart.vue').default);

Vue.component('member-orders-page', require('./components/Shop/OrdersPage.vue').default);
Vue.component('member-orders-list', require('./components/Shop/OrdersList.vue').default);
Vue.component('member-order-create', require('./components/Shop/OrderCreate.vue').default);
